import { z } from "zod";

export const useResetPasswordForm = () => {
    const schema = z
        .object({
            email: z.string().email().min(1),
            token: z.string().min(1),
            password: z.string().min(1),
            confirmPassword: z.string().min(1),
        })
        .refine(data => data.password === data.confirmPassword, { message: 'Passwords do not match', path: ['confirmPassword'] });
    return {
        schema,
    };

}